import * as React from 'react';

import { useResponsiveBreakpoints } from '@src/hooks/useMediaQuery';

interface PopularSearchesProps {
  title?: string;
  searches?: any[];
  className?: string;
  onSearchClick?: (search: any) => void;
  hasCollectionResults?: boolean;
  hasSuggestedQueryResults?: boolean;
}

export const PopularSearches: React.FC<PopularSearchesProps> = ({
  title = 'Popular searches',
  searches = [],
  className = '',
  onSearchClick,
  hasCollectionResults = false,
  hasSuggestedQueryResults = false
}) => {
  const { isMobile, isTablet, isUltrawide } = useResponsiveBreakpoints();

  // Don't show popular searches if there are collection results, suggested query results, or no searches available
  if ((hasCollectionResults || hasSuggestedQueryResults) || !searches || searches.length === 0) return null;

  return (
    <div className={`flex flex-col gap-2 ${isMobile || isTablet ? 'pb-8' : ''} ${className}`}>
      <p className={`mb-2 ${isMobile || isTablet ? 'b1--bold' : 'b1--bold'}`}>{title}</p>
      <div className='flex flex-col gap-y-4 items-start'>
        {searches.map((search: any, index: number) => (
          <button
            key={index}
            onClick={() => onSearchClick?.(search)}
            className={`no-underline hover:underline ${isMobile || isTablet ? 'b3' : 'b3'}`}
          >
            {search}
          </button>
        ))}
      </div>
    </div>
  );
};
